import { useEffect, useRef } from "react";

interface FirstTimeInteractionInterface {
	onInteraction: () => void;
	dependencyArray: Array<unknown>;
}

export const useFirstTimeInteraction = ({ onInteraction, dependencyArray }: FirstTimeInteractionInterface) => {
	const hasInteracted = useRef(false);
	const isInitialRender = useRef(true);

	useEffect(() => {
		if (isInitialRender.current) {
			isInitialRender.current = false;
			return;
		}

		if (!hasInteracted.current) {
			onInteraction();
			hasInteracted.current = true;
		}
	}, dependencyArray);
};
